import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { ResourceCountries } from '../models/resource-countries.model';
import { ResourceCountriesRepository } from '../repositories/resource-countries.repository';

export class GetResourceCountriesUseCase
    implements UseCase<void, ResourceCountries>
{
    constructor(private readonly repository: ResourceCountriesRepository) {}

    execute(): Observable<ResourceCountries> {
        return this.repository.getResourceCountries();
    }
}
